import type { SVGProps } from 'react';
import React from 'react';

export const Language = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="25"
    fill="none"
    viewBox="0 0 26 25"
    id="globe"
  >
    <circle cx="13" cy="12.5" r="12" stroke="#fff"></circle>
    <path
      stroke="#fff"
      d="M17 12.5c0 3.41-.498 6.475-1.289 8.67-.395 1.099-.855 1.953-1.34 2.524-.487.572-.952.806-1.371.806-.419 0-.884-.234-1.37-.806-.486-.57-.946-1.425-1.341-2.524C9.498 18.974 9 15.91 9 12.5s.498-6.475 1.289-8.67c.395-1.099.855-1.953 1.34-2.524C12.116.734 12.581.5 13 .5c.419 0 .884.234 1.37.806.486.57.946 1.425 1.341 2.525C16.502 6.025 17 9.09 17 12.5z"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="square"
      d="M2.275 8.5h21.45m-21.45 8h21.45"
    ></path>
  </svg>
);
